import type { MongoAbility } from "@casl/ability";
import { createMongoAbility } from "@casl/ability";

export type Actions = "create" | "read" | "update" | "delete" | "manage";

export type Subjects = "Auth" | "Admin" | "AclDemo" | "all";

export type AppAbility = MongoAbility<[Actions, Subjects]>;

export const AppAbility = createMongoAbility() as AppAbility;

export interface UserAbility {
  action: Actions
  subject: Subjects
}
